import React, { useState, useEffect } from "react";
import "./UserProfile.scss";
import Profile from "../../../assets/Images/blank-profile-picture-973460_960_720.webp";
import { MdEdit } from "react-icons/md";
import axios from "axios";
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import EditPopup from "./EditPopup";
import { FaUser } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";

import { FaPhone } from "react-icons/fa";
import { FaGraduationCap } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { MdOutlineWork } from "react-icons/md";
import { FaGithub } from "react-icons/fa";
import { Box, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import mail from "../../../assets/Images/PngItem_112427 1.png";
import google from "../../../assets/Images/8484d672e2b94cb58d5491bcedc63bdec0ec898f.png";
import Swal from "sweetalert2";


const UserProfile = () => {
  const [user, setUser] = useState(null);
  const [accountOwnerDetails, setAccountOwnerDetails] = useState(null);
  // const [about, setAbout] = useState('');
  // const [editAboutMode, setEditAboutMode] = useState(false);
  // const [newAbout, setNewAbout] = useState('');

  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const navigate = useNavigate("");
  const location = useLocation();

  const [popupType, setPopupType] = useState("");
  const [popupMode, setPopupMode] = useState("edit");
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [isOpenAccount, setIsOpenAccount] = useState(false);
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [data, setData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const [isEditable, setIsEditable] = useState(false);
  const [mfa, setMfa] = useState(false);

  const [configs, setConfigs] = useState([
    { domain: "", fromEmail: "", appPassword: "", saved: false },
  ]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    if (isOpenAccount) {
      // Call backend API when popup opens
      fetch(`${baseURL}/api/user`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          setMfaEnabled(data.mfaEnabled || false);
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
        });
    }
  }, [isOpenAccount]);

  useEffect(() => {
    if (location.state?.updated) {
      fetchAccountOwnerDetails();
    }
  }, [location.state]);

  const fetchAccountOwnerDetails = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(`${baseURL}/api/account-owner`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("fetchAccountOwnerDetails data:", response.data);

      if (
        response.data.accountOwnerDetails &&
        Array.isArray(response.data.accountOwnerDetails)
      ) {
        setAccountOwnerDetails(response.data.accountOwnerDetails[0]);
      }
    } catch (err) {
      console.error("Error fetching account owner details:", err);
    }
  };

    const getConfigs = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${baseURL}/api/get-configs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const updated = res.data.configs.map((cfg) => ({
        ...cfg,
        saved: true,
      }));
      setConfigs(updated);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAccountOwnerDetails();
    getConfigs();
  }, []);

  const handleSave = async (type, updatedData) => {
  try {
    const token = localStorage.getItem("token");

    const updatedDetails = {
      ...accountOwnerDetails,
      [type]: updatedData,
    };

    setAccountOwnerDetails(updatedDetails);
    setShowPopup(false);

    const response = await fetch(`${baseURL}/api/account-owner`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedDetails),
    });

    if (response.ok) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Details updated successfully!",
        confirmButtonColor: "#3085d6",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update details. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  } catch (error) {
    console.error("Error updating details:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Something went wrong. Please try again later.",
      confirmButtonColor: "#d33",
    });
  }
};


  const handleCloseAccount = () => {
    setIsOpenAccount(false);
  };

  const handleToggleMFA = async () => {
    const newMfaStatus = !mfaEnabled;
    setMfaEnabled(newMfaStatus);

    try {
      // Call your backend API to update MFA setting
      const response = await fetch(`${baseURL}/api/update-mfa`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          mfaEnabled: newMfaStatus,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update MFA setting");
      }

      const data = await response.json();
      console.log("MFA updated successfully:", data);
    } catch (error) {
      console.error("Error updating MFA:", error);
      // Rollback UI if API fails
      setMfaEnabled(!newMfaStatus);
    }
  };

  const handleOpenPopup = (mode, type) => {
    setPopupMode(mode);
    setPopupType(type);
    const data = mode === "edit" ? accountOwnerDetails[type] : {};
    setPopupData(data);
    setShowPopup(true);
  };

  const handleEditClick = () => {
    navigate("/accountowner", {
      state: {
        mode: "edit",
        formData: accountOwnerDetails,
      },
    });
  };

  const CustomSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 60,
    height: 25,
    padding: 0,
    display: "flex",
    marginLeft: 10,
    "& .MuiSwitch-switchBase": {
      padding: 4,
      "&.Mui-checked": {
        transform: "translateX(26px)",
        color: "grey",
        "& + .MuiSwitch-track": {
          backgroundColor: "grey",
          "&:before": {
            content: '"ON"',
            left: 8,
          },
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 0 0 / 20%)",
      width: 19,
      height: 19,
      borderRadius: "50%",
      backgroundColor: "#FCB124",
      marginLeft: 5,
    },
    "& .MuiSwitch-track": {
      position: "relative",
      borderRadius: 34 / 2,
      backgroundColor: "grey",
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      "&:before": {
        content: '"OFF"',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        left: 34,
        color: "white",
        fontSize: 12,
        fontWeight: 600,
      },
    },
  }));

  const handleMFA = () => {
    if (!isEditable) {
      // First click: enable edit mode
      setIsEditable(true);
      setMfaEnabled(true);
      setMfa(true);
      setIsEditing(true);
    } else {
      navigate("/multifactor");
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...configs];
    updated[index][field] = value;

    // If updating the 'domain' field, validate it
    if (field === "domain") {
      const domain = value.trim().toLowerCase();
      const isValidDomain = Object.keys(appPasswordLinks).includes(domain);
      updated[index].domainError = !isValidDomain;
    }

    setConfigs(updated);
  };

  const addRow = () => {
    setConfigs([...configs, { domain: "", fromEmail: "", appPassword: "" }]);
  };

  const removeRow = (index) => {
    const updated = configs.filter((_, i) => i !== index);
    setConfigs(updated);
  };

  const appPasswordLinks = {
    "gmail.com": "https://myaccount.google.com/apppasswords",
    "googlemail.com": "https://myaccount.google.com/apppasswords",
    "zoho.com": "https://accounts.zoho.com/home#security/security_ips",
    "zohomail.com": "https://accounts.zoho.com/home#security/security_ips",
    "outlook.com": "https://account.live.com/proofs/AppPassword",
    "hotmail.com": "https://account.live.com/proofs/AppPassword",
    "live.com": "https://account.live.com/proofs/AppPassword",
  };

  const handleAppPasswordFocus = (index) => {
    const domain = configs[index].domain.toLowerCase().trim();
    const link = appPasswordLinks[domain];
    if (link) {
      window.open(link, "_blank");
    } else {
      setError("Please check the entered domain");
      return;
    }
  };

  const handleDelete = async (index) => {
    const token = localStorage.getItem("token");
    const configToDelete = configs[index];

    if (configToDelete._id) {
      try {
        await fetch(`${baseURL}/api/delete-config/${configToDelete._id}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch (error) {
        setMessage("Failed to delete config.");
        return;
      }
    }

    const updated = configs.filter((_, i) => i !== index);
    setConfigs(updated);
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem('token');
  const unsavedConfigs = configs.filter((config) => !config.saved);

  if (unsavedConfigs.length === 0) {
    setMessage("No new configs to save.");
    return;
  }

  try {
    const response = await axios.post(`${baseURL}/api/save-config`, {
      configs: unsavedConfigs},
      {
        headers:{
          'Authorization': `Bearer ${token}`
        }
      }
    );

    const updatedConfigs = configs.map((config) =>
      !config.saved ? { ...config, saved: true } : config
    );

    setConfigs(updatedConfigs);
    getConfigs();
    setMessage("New configurations saved successfully!");
  } catch (error) {
    console.error("Error saving configs:", error);
    setMessage("Failed to save configs.");
  }
};


  return (
    <>
      <div className="user-top-container">
        <div className="user-container-1">
          <div>
            <button
              onClick={handleEditClick}
              style={{
                backgroundColor: "#Fcab12",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                color: "white",
                width: "70px",
                marginTop: "40px",
                justifyContent: "end",
                height: "25px",
              }}
            >
              Edit
            </button>
          </div>
          <Box className="user-profile-container">
            <div className="card">
              <div className="plan-img">
                <FaUser />
                <p className="plan">Account Details</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="profile-img">
                  <img
                    className="img"
                    src={Profile}
                    alt="profile"
                    width="100px"
                    height="100px"
                  />
                </div>
              </div>
              {accountOwnerDetails ? (
                <div className="user-details">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div style={{ fontSize: "10px", marginTop: "14px" }}>
                        {" "}
                        <FaUser />{" "}
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          marginTop: "10px",
                        }}
                      >
                        {accountOwnerDetails.primaryContact?.name}
                      </div>{" "}
                    </div>
                    <div>
                      <MdEdit
                        style={{
                          marginRight: "20px",
                          color: "Fcab12",
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleOpenPopup("edit", "primaryContact")
                        }
                      />
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", gap: "8px", marginTop: "10px" }}
                  >
                    <div>
                      <MdEmail />
                    </div>
                    <div className="email">
                      {accountOwnerDetails.primaryContact?.email}
                    </div>
                  </div>
                </div>
              ) : (
                <p>Update name & Email..</p>
              )}
              {accountOwnerDetails ? (
                <div className="user-details">
                  <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ marginTop: "15px" }}>
                      <FaBuilding />
                    </div>
                    <div
                      style={{
                        paddingTop: "14px",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        window.open("https://www.merkatintellekt.com")
                      }
                    >
                      {accountOwnerDetails.experience?.company}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ marginTop: "15px" }}>
                      <FaPhone />
                    </div>
                    <div style={{ paddingTop: "14px", color: "#666" }}>
                      {" "}
                      {accountOwnerDetails.primaryContact?.contactNumber}
                    </div>
                  </div>
                  <div style={{ paddingTop: "10px", color: "#666" }}>
                    {" "}
                    {accountOwnerDetails.billingAddress?.state},{" "}
                    {accountOwnerDetails.billingAddress?.country}
                  </div>
                </div>
              ) : (
                <p>Add account details...</p>
              )}
            </div>
            <div className="card-column">
              <div className="card-3">
                <div className="plan-img">
                  <FaGraduationCap />
                  <p className="plan">Education And Skills</p>
                </div>
                {accountOwnerDetails ? (
                  <div className="user-details">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="user-education">
                        <div>
                          <strong>Education</strong>
                        </div>
                      </div>
                      <div>
                        <MdEdit
                          style={{
                            marginRight: "10px",
                            color: "Fcab12",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenPopup("edit", "education")}
                        />
                      </div>
                    </div>
                    <div className="edit-details">
                      <div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <div style={{ marginTop: "15px" }}>
                            <FaGraduationCap />
                          </div>
                          <div style={{ paddingTop: "14px" }}>
                            {accountOwnerDetails.education?.school} ,{" "}
                            {accountOwnerDetails.education?.eduenddate?.slice(
                              0,
                              4
                            )}
                          </div>
                        </div>
                        <div
                          className="email"
                          style={{ paddingTop: "10px", paddingLeft: "22px" }}
                        >
                          {accountOwnerDetails.education?.degree}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{ paddingTop: "20px" }}
                            className="user-education"
                          >
                            <div>
                              <strong>Skills</strong>
                            </div>
                          </div>
                          <div>
                            <MdEdit
                              style={{
                                marginTop: "5px",
                                color: "#Fcab12",
                                fontSize: "20px",
                                cursor: "pointer",
                                paddingLeft: "50px",
                                marginLeft:"145px"
                              }}
                              onClick={() => handleOpenPopup("edit", "skills")}
                            />
                          </div>
                        </div>
                        <div className="email">
                          {accountOwnerDetails.skills?.skills}
                        </div>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <div style={{ color: "blue", marginTop: "15px" }}>
                            <FaLinkedin />
                          </div>
                          <div style={{ paddingTop: "14px", color: "blue" }}>
                            {accountOwnerDetails.skills?.linkedIn}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div></div>
                  </div>
                ) : (
                  <div>Add education.. </div>
                )}
              </div>
            </div>
            <div className="card-column">
              <div style={{ marginLeft: "20px" }} className="card">
                <div className="plan-img">
                  <MdOutlineWork />
                  <p className="plan">Experience</p>
                </div>
                {accountOwnerDetails ? (
                  <div className="user-details">
                    <div className="user-experience">
                      <div>
                        <strong>Experience</strong>
                      </div>
                      <div></div>
                    </div>
                    <div className="edit-details">
                      <div>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <div style={{ marginTop: "15px" }}>
                            <MdOutlineWork />
                          </div>
                          <div style={{ paddingTop: "14px" }}>
                            {accountOwnerDetails.experience?.company},{" "}
                            {accountOwnerDetails.experience?.comstartdate?.slice(
                              0,
                              4
                            )}{" "}
                            -
                            {accountOwnerDetails.experience
                              ? "currentlyWorking"
                                ? " Present"
                                : accountOwnerDetails.experience?.comenddate?.slice(
                                    0,
                                    4
                                  )
                              : null}{" "}
                          </div>
                        </div>
                        <div
                          className="email"
                          style={{
                            color: "#666",
                            paddingTop: "10px",
                            marginLeft: "18px",
                          }}
                        >
                          {accountOwnerDetails.experience?.designation}
                        </div>
                        <div style={{ paddingTop: "20px" }}>
                          <div className="user-experience">
                            <strong>About</strong>
                          </div>
                          <div style={{ marginTop: "10px", color: "#333" }}>
                            {accountOwnerDetails.skills?.about}{" "}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <div style={{ marginTop: "15px" }}>
                            <FaGithub />
                          </div>
                          <div
                            style={{
                              paddingTop: "14px",
                              color: "blue",
                              marginBottom: "20px",
                            }}
                          >
                            {accountOwnerDetails.skills?.gitHub}
                          </div>
                        </div>
                      </div>
                      <div>
                        <MdEdit
                          style={{
                            marginRight: "20px",
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#Fcab12",
                          }}
                          onClick={() => handleOpenPopup("edit", "experience")}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>Add experience....</div>
                )}
              </div>

              {showPopup && (
                <EditPopup
                  type={popupType}
                  mode={popupMode}
                  data={popupData}
                  onClose={() => setShowPopup(false)}
                  onSave={handleSave}
                />
              )}
            </div>
          </Box>
        </div>
        <div className="user-container">
          <h2>Email Configuration</h2>
          <form onSubmit={handleSubmit}>
            {configs.map((config, index) => (
              <div key={index} className="config-row">
                <div className="config-flex">
                <input
                  type="text"
                  placeholder={
                    config.domainError
                      ? "Invalid domain"
                      : "Domain (e.g., gmail.com)"
                  }
                  value={config.domain}
                  disabled={config.saved}
                  onChange={(e) =>
                    handleChange(index, "domain", e.target.value)
                  }
                  style={{
                    borderColor: config.domainError ? "red" : "#ccc",
                  }}
                  autoComplete="off"
                  required
                />
                <p>{config.domainError && (
                  <small style={{ color: "red" }}>
                    Please enter a valid domain
                  </small>
                )} </p>
                </div>
                <div className="config-flex">

                <input
                  type="email"
                  placeholder="From Email"
                  value={config.fromEmail}
                  disabled={config.saved}
                  onChange={(e) =>
                    handleChange(index, "fromEmail", e.target.value)
                  }
                  autoComplete="off"
                  required
                />
                </div>
                <div className="config-flex">
                <input
                  type="password"
                  value={config.appPassword}
                  disabled={config.saved}
                  placeholder="App Password"
                  onChange={(e) =>
                    handleChange(index, "appPassword", e.target.value)
                  }
                  onFocus={() => handleAppPasswordFocus(index)}
                  style={{ borderColor: error ? "red" : "#ccc" }}
                  autoComplete="off"
                  required
                />
                </div>
                {config.saved ? (
                  <button
                    type="button"
                    onClick={() => handleDelete(index)}
                    className="delete-btn"
                    style={{width:'90px', height:'35px'}}
                  >
                    Delete
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => removeRow(index)}
                    className="remove-btn"
                    style={{width:'50px', height:'30px'}}
                  >
                    ❌
                  </button>
                )}
              </div>
            ))}

            <div className="config-row">
              <button type="button" onClick={addRow}>
                ➕ Add Another
              </button>
              <button type="submit">✅ Save Config</button>
            </div>

            {message && <p>{message}</p>}
          </form>
        </div>
        <div className="mfa-notifications">
          <div>
            <div
              className="notification-settings"
              style={{ textAlign: "start" }}
            >
              Notification Settings
            </div>
          </div>
          <div
            style={{ marginTop: "20px" }}
            open={isOpenAccount}
            onClose={handleCloseAccount}
            aria-labelledby="account-dialog-title"
            maxWidth="xs"
            fullWidth
          >
            <div
              className="mfa-toggle"
              style={{
                marginTop: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ fontSize: "15px" }}>
                {" "}
                <b>MFA</b>{" "}
                <span style={{ color: "#00000080", fontWeight: "500" }}>
                  (Multi Factor Authentication)
                </span>
              </div>

              <CustomSwitch
                checked={mfaEnabled}
                onChange={handleToggleMFA}
                disabled={!isEditable}
              />
            </div>
          </div>
          {mfa && (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "5px",
                  marginLeft: "330px",
                  marginTop: "10px",
                }}
              >
                <div>
                  <img src={mail} alt="mail" width="20px" />
                </div>
                <div style={{ fontSize: "15px", fontWeight: "700" }}>Email</div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "10px",
                  alignItems: "center",
                  gap: "5px",
                  marginLeft: "330px",
                }}
              >
                <div>
                  <img src={google} alt="google" width="20px" />
                </div>
                <div style={{ fontSize: "15px", fontWeight: "700" }}>
                  Google Authentication
                </div>
              </div>
            </div>
          )}
          <div>
            <button className="mfa-edit-btn" onClick={handleMFA}>
              {isEditable ? "Update" : "Edit"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;